import { Button, Input, Box, Typography, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChangeProfile } from "../../hooks";
import { changeLoading } from "../../slices";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ChangePasswordBox = ({ userName, email }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [isValidNewPassword, setIsValidNewPassword] = useState(false);
  const [isPasswordMatch, setIsPasswordMatch] = useState(false);
  const dispatch = useDispatch();
  const { fetchResultsData, fetchedData } = useChangeProfile();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  useEffect(() => {
    setNewEmail(email || "");
  }, [email]);
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setIsValidNewPassword(passwordRegex.test(value));
  };

  const handleRepeatPasswordChange = (e) => {
    const value = e.target.value;
    setRepeatPassword(value);
    setIsPasswordMatch(value === newPassword && isValidNewPassword);
  };
  const navigate = useNavigate();
  const isFormValid = isValidNewPassword && isPasswordMatch;

  const handleChange = async () => {
    // Handle password change logic here
    if (!currentPassword || !repeatPassword) {
      alert("Моля, попълнете всички полета.");
      return;
    }
    dispatch(changeLoading(true));
    try {
      const response = await fetchResultsData({
        repeatPassword,
        currentPassword,
      });
      if (response?.JSonValue === "Ok") {
        const successMessage =
          response.Details.find((item) => item.Type === 1)?.Message ||
          "Паролата е променена успешно!";
        alert(successMessage);
        navigate("/profile");
      } else if (response?.JSonValue === "Error") {
        const errorMessages = response.Details.filter((item) => item.Type === 2)
          .map((item) => `${item.PropertyName}: ${item.Message}`)
          .join("\n");

        alert(errorMessages || "Грешка при смяна на паролата.");
      } else {
        alert("Неочакван отговор от сървъра.");
      }
    } catch (error) {
      alert("Грешка: " + (error.message || "Неизвестна грешка."));
    }

    dispatch(changeLoading(false));
  };
  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 400,
        mx: "auto",
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: 3,
        marginTop: "10px",
      }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        Промяна парола/имейл
      </Typography>
      {/* <Input
        value={patientName}
        readOnly
        fullWidth
        placeholder="Име на пациент"
        sx={{ mb: 2 }}
      /> */}
      <TextField
        label="Email"
        variant="outlined"
        value={newEmail}
        // onChange={(e) => setNewEmail(e.target.value)}
        fullWidth
        placeholder="Потребителско име / Email"
        sx={{ mb: 2 }}
      />
      {/* <Input
        type="password"
        fullWidth
        placeholder="Текуща парола"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        sx={{ mb: 2 }}
      /> */}
      <Box sx={{ position: "relative", width: "100%", mb: 2 }}>
        <Input
          type={showCurrentPassword ? "text" : "password"}
          fullWidth
          placeholder="Текуща парола"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          autoComplete="new-password" // to fill it auto or not?
        />
        {currentPassword && (
          <Button
            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
            sx={{ position: "absolute", right: 0, top: 0, minWidth: 40 }}
          >
            {showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </Button>
        )}
      </Box>
      {/* <Input
        type="password"
        fullWidth
        placeholder="Нова парола"
        value={newPassword}
        onChange={handleNewPasswordChange}
        sx={{ mb: 1 }}
        error={!isValidNewPassword && newPassword.length > 0}
      /> */}
      <Box sx={{ position: "relative", width: "100%", mb: 1 }}>
        <Input
          type={showNewPassword ? "text" : "password"}
          fullWidth
          placeholder="Нова парола"
          value={newPassword}
          onChange={handleNewPasswordChange}
          error={!isValidNewPassword && newPassword.length > 0}
        />
        {newPassword && (
          <Button
            onClick={() => setShowNewPassword(!showNewPassword)}
            sx={{ position: "absolute", right: 0, top: 0, minWidth: 40 }}
          >
            {showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </Button>
        )}
      </Box>
      {!isValidNewPassword && newPassword && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          Паролата трябва да е поне 8 знака, да съдържа главни, малки букви,
          число и символ.
        </Typography>
      )}
      {/* <Input
        type="password"
        fullWidth
        placeholder="Повторете новата парола"
        value={repeatPassword}
        onChange={handleRepeatPasswordChange}
        disabled={!isValidNewPassword}
        sx={{ mb: 1 }}
        error={!isPasswordMatch && repeatPassword.length > 0}
      /> */}
      <Box sx={{ position: "relative", width: "100%", mb: 1 }}>
        <Input
          type={showRepeatPassword ? "text" : "password"}
          fullWidth
          placeholder="Повторете новата парола"
          value={repeatPassword}
          onChange={handleRepeatPasswordChange}
          disabled={!isValidNewPassword}
          error={!isPasswordMatch && repeatPassword.length > 0}
        />
        {repeatPassword && (
          <Button
            onClick={() => setShowRepeatPassword(!showRepeatPassword)}
            sx={{ position: "absolute", right: 0, top: 0, minWidth: 40 }}
          >
            {showRepeatPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </Button>
        )}
      </Box>
      {!isPasswordMatch && repeatPassword && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          Паролите не съвпадат.
        </Typography>
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          disabled={!isFormValid}
          onClick={handleChange}
        >
          Промени
        </Button>
        <Button
          variant="outlined"
          // color="danger"
          onClick={() => {
            navigate(-1);
          }}
          sx={{ color: "red" }}
        >
          Отказ
        </Button>
      </Box>
    </Box>
  );
};

export default ChangePasswordBox;
